import React from 'react';
import { Link } from 'react-router-dom';
import Routes from 'routes';
import defaultLocales from 'globals/locales/default';
import { useBillingType } from 'globals/hooks/useBillingType';
import { UserBillingType, UserRole } from 'globals/types';
import { useAppContext } from 'contexts/AppContext';
import { useRole } from 'globals/hooks/useRole';
import { Button } from './FsScreenOfDeathBox.style-elements';

interface UseButtonProps {
  callback: (state: boolean) => void;
}

export const useButton = ({
  callback,
}: UseButtonProps): React.ReactElement | null => {
  const { isUpgraded } = useAppContext();
  const isUserBillingTypeStandard = useBillingType(UserBillingType.STANDARD);
  const isUserBillingTypeEnterprise = useBillingType(
    UserBillingType.ENTERPRISE
  );
  const isAdminOrAccountant = useRole([UserRole.ADMIN, UserRole.ACCOUNTANT]);
  const isUserBillingTypeExcluded = useBillingType(UserBillingType.EXCLUDED);
  const isButton = isAdminOrAccountant && !isUserBillingTypeExcluded;
  if (!isButton) return null;
  switch (true) {
    case isUpgraded && isUserBillingTypeStandard:
      return (
        <Button component={Link} to={Routes.BILLINGS}>
          {defaultLocales.upgradeMethodPayment}
        </Button>
      );
    case isUpgraded && isUserBillingTypeEnterprise:
      return (
        <Button component={Link} to={Routes.BILLINGS}>
          {defaultLocales.upgradeMethodPayment}
        </Button>
      );
    case !isUpgraded && isUserBillingTypeStandard:
      return (
        <Button onClick={() => callback(true)}>{defaultLocales.upgrade}</Button>
      );
    case !isUpgraded && isUserBillingTypeEnterprise:
      return (
        <Button component={Link} to={Routes.UPGRADE}>
          {defaultLocales.upgrade}
        </Button>
      );
    default:
      return null;
  }
};
